<template>
  <div>
    <event-head></event-head>
    <normal-card title="基本信息" class="mt-5">
      <div class="infoPage">
        <div class="overviewCommand_detail">
          <div class="basic-left">
            <el-form label-width="100px" :rules="rules">
              <el-form-item label="赛事名称:">
                <el-input v-model="stepOneForm.matchTitle" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="主办单位:">
                <el-input v-model="stepOneForm.organizer" placeholder="请输入"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="basic-right">
            <div>
              <f-image-upload v-model="stepOneForm.matchLogo" :width="'110px'" :height="'110px'"
                style="margin-bottom: 20px;"></f-image-upload>
              <span class="uploadTitle">赛事logo（建议1：1）</span>
            </div>
          </div>
          <div class="basic-right">
            <div>
              <f-image-upload v-model="matchPoster" :width="'110px'" :height="'110px'"
                style="margin-bottom: 20px;"></f-image-upload>
              <span class="uploadTitle">赛事海报（建议1：1）</span>
            </div>
          </div>
          <div class="basic-right">
            <div>
              <f-image-upload v-model="matchPoster" :width="'110px'" :height="'110px'"
                style="margin-bottom: 20px;"></f-image-upload>
              <span class="uploadTitle">赛事视频（30M以下）</span>
            </div>
          </div>
          <div class="basic-right">
            <div>
              <f-image-upload v-model="matchChart" :width="'110px'" :height="'110px'"
                style="margin-bottom: 20px;"></f-image-upload>
              <span class="uploadTitle">对阵图表</span>
            </div>
          </div>
        </div>
      </div>
    </normal-card>
    <normal-card title="球场信息" class="mt-5">
      <div class="timePage">
        <div class="front-part">
          <el-form label-width="240px" :rules="rules">
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="承办球场:">
                <el-input v-model="stepOneForm.stadium" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="10">
              <el-form-item label="球场地址:">
                <el-input v-model="stepOneForm.stadiumAddress" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
              <el-form-item label="球场经度:">
                <el-input v-model="stepOneForm.longitude" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="10">
              <el-form-item label="球场纬度:">
                <el-input v-model="stepOneForm.latitude" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          </el-form>
        </div>
      </div>
    </normal-card>
    <normal-card title="时间信息" class="mt-5">
      <div class="timePage">
        <div class="front-part">
          <el-form label-width="240px" :rules="rules">
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="赛事开始日:">
                  <template>
                    <el-date-picker v-model="stepOneForm.beginDate" type="date" placeholder="请选择"
                      value-format="yyyy-MM-dd"></el-date-picker>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="赛事结束日:">
                  <template>
                    <el-date-picker v-model="stepOneForm.endDate" type="date" placeholder="请选择"
                      value-format="yyyy-MM-dd"></el-date-picker>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </normal-card>
    <normal-card title="赛事信息" class="mt-5">
      <div class="timePage">
        <div class="front-part">
          <el-form label-width="240px" :rules="rules">
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="赛事类型:">
                  <el-select v-model="stepOneForm.matchType">
                    <el-option v-for="item in propertyOptionList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
              <el-col :span="10">
                <el-form-item label="赛制:">
                <el-select v-model="stepThreeForm.matchFormat">
                    <el-option v-for="item in entryOption" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="组别:">
                <el-select v-model="stepThreeForm.matchGroup">
                    <el-option v-for="item in matchGroup" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
              <el-col :span="10">
                <el-form-item label="场制:">
                <el-select v-model="stepThreeForm.matchFieldType">
                    <el-option v-for="item in matchTypeOption" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="联系方式:" prop="contact">
                <el-input v-model="stepFourForm.contact" placeholder="请输入" ></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="10">
                <el-form-item label="举办城市:" prop="city">
                  <el-cascader v-model="stepFourForm.city" :options="province.city" clearable></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          </el-form>
        </div>
      </div>  
    </normal-card>
    <div class="btn-com">
      <el-button class="save-btn" @click="handleSave">保存</el-button>
    </div>
    <!-- 地图弹窗 -->
    <el-dialog :visible.sync="showMapDialog" v-if="showMapDialog" title="地图选点">
      <Map @map-submit="mapSubmit" :address="stepOneForm.stadiumAddress"></Map>
    </el-dialog>
  </div>
</template>

<script>
import Map from '@/views/eventManage/components/Map';
import FImageUpload from '@/common/components/Upload/f-image-upload';
import EventHead from '@/common/components/eventHead/EventHead';
import normalCard from '@/common/components/normal/NormalCard';
import province from "@/apidata/province.json";
export default {
  components: {
    Map,
    FImageUpload,
    EventHead,
    normalCard,
  },
  /**
   * 表单属性采用配置方式， 1:输入框  2:下拉选择  3:图片上传  4:日期选择
   */
  data() {
    return {
      disabled: false,
      matchList: [],
      title: '',
      dialogVisible: false,
      showMapDialog: false,
      province:province,
      propertyOptionList: [],
      entryOption: [
        {
          value: 1,
          label: "联赛制"
        },
        {
          value: 2,
          label: "赛会制"
        },
        {
          value: 3,
          label: "杯赛制"
        },
      ],
      matchTypeOption:[
      {
          value: 5,
          label: '5人制',
        },
        {
          value: 6,
          label: '6人制',
        },
        {
          value: 7,
          label: '7人制',
        },
        {
          value: 8,
          label: '8人制',
        },
        {
          value: 9,
          label: '9人制',
        },
        {
          value: 10,
          label: '10人制',
        },
        {
          value: 11,
          label: '11人制',
        },
      ],
      matchGroup: [
      {
          value: 1,
          label: '成人组',
        },
        {
          value: 2,
          label: '少儿组',
        },
        {
          value: 5,
          label: 'U5',
        },
        {
          value: 18,
          label: 'U18组',
        },
        {
          value: 30,
          label: '30+组',
        },
        {
          value: 35,
          label: '35+组',
        },
        {
          value: 40,
          label: '40+组',
        },
        {
          value: 50,
          label: '50+组',
        }
      ],
      rules: {
        matchLogo: [{ required: true, message: '请上传', trigger: 'change' }],
        matchTitle: [{ required: true, message: '请输入', trigger: 'blur' }],
        organizer: [{ required: true, message: '请输入', trigger: 'blur' }],
        city: [{ required: true, message: '请输入', trigger: 'change' }],
        stadium: [{ required: true, message: '请输入', trigger: 'blur' }],
        stadiumAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
        beginDate: [{ required: true, message: '请选择', trigger: 'change' }],
        endDate: [{ required: true, message: '请选择', trigger: 'change' }],

        matchType: [{ required: true, message: '请选择', trigger: 'change' }],
        teamGroupCount: [{ required: true, message: '请输入', trigger: 'blur' }],
        teamPlayerCount: [{ required: true, message: '请输入', trigger: 'blur' }],
        totalGame: [{ required: true, message: '请输入', trigger: 'blur' }],


        matchGroup: [{ required: true, message: '请选择', trigger: 'change' }],
        entryType: [{ required: true, message: '请选择', trigger: 'change' }],
        entryFee: [{ required: true, message: '请输入', trigger: 'change' }],
        contact: [{ required: true, message: '请输入电话号码', trigger: 'blur' },
                    { pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur', }],
      },
      stepOneForm: {
        matchLogo: '',
        matchTitle: '',
        matchChart:'',
        organizer: '',
        city: '',
        stadium: '',
        stadiumAddress: '',
        matchType: '',
        beginDate: '',
        endDate: '',
      },
      stepOneColumns: [
        { title: '赛事logo（建议1:1上传）：', type: 3, code: 'matchLogo', editable: true },
        { title: '赛事名称：', type: 1, code: 'matchTitle', editable: true },
        { title: '主办单位：', type: 1, code: 'organizer', editable: true },
        { title: '举办城市：', type: 1, code: 'city', editable: true },
        { title: '承办球场：', type: 1, code: 'stadium', editable: true },
        { title: '球场地址：', type: 1, code: 'stadiumAddress', editable: false },
        {
          title: '赛事类型：',
          type: 2,
          code: 'matchType',
          
        }
      ],
      stepThreeForm: {
        matchFormat: '',
        matchFieldType: '',
        matchGroup: '',
        teamGroupCount: '',
        teamPlayerCount: '',
        totalGame: '',
      },
      stepFourForm: {
        contact: '',
        entryType: '',
        entryFee: 0,
        earnestMoney: 0,
        minSignTeam: 0,
        maxSignTeam: 0,
        city:""
      },
      matchData: {},
      matchInfo: {},
      contact: '',
    };
  },
  mounted() {
    
    if (localStorage.getItem('matchId')) {
      this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
      this.getMatchDetail();
      this.initOrgEntryMatchType();
    } else {
      this.$confirm('暂无赛事！！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
    }       
  },
  methods: {
         // 获取用户的可用赛事类型
         async initOrgEntryMatchType() {
            const { res } = await this.$http.get('/Match/MatchTypeList');
            //对象转数组
            const arr = Object.keys(res.data).map(value => ({ value, label: res.data[value] }));
            this.propertyOptionList = arr;
        },
    // 获取赛事信息
    async getMatchDetail() {
      const { res } = await this.$http.get(`/Match/MatchInfo/${this.matchInfo.matchId}`);
      this.stepOneForm = res.data.info;
      this.propertyOptionList.forEach(t =>{
        if(res.data.info.matchType == t.value){
          this.stepOneForm.matchType = t.label;
        }
      });
      this.stepThreeForm = res.data.formatInfo;
      this.stepFourForm = res.data.extInfo;
      this.stepFourForm.city = res.data.info.city;
    },

    // 保存
    handleSave() {
      if (Array.isArray(this.stepFourForm.city)) {
        this.stepFourForm.city = this.stepFourForm.city[1]
      }
      this.matchData.matchId = this.stepOneForm.matchId;
      this.matchData.matchTitle = this.stepOneForm.matchTitle;
      this.matchData.matchLogo = this.stepOneForm.matchLogo;
      this.matchData.matchPoster = "";
      this.matchData.organizer = this.stepOneForm.organizer;
      this.matchData.stadium = this.stepOneForm.stadium;
      this.matchData.stadiumAddress = this.stepOneForm.stadiumAddress;
      this.matchData.longitude = this.stepOneForm.longitude;
      this.matchData.latitude = this.stepOneForm.latitude;
      this.matchData.beginDate = this.stepOneForm.beginDate;
      this.matchData.endDate = this.stepOneForm.endDate;
      this.matchData.city = this.stepFourForm.city;
      this.propertyOptionList.forEach(t =>{
        if(this.stepOneForm.matchType == t.label){
          this.stepOneForm.matchType = t.value;
        }
      });
      this.matchData.matchType = this.stepOneForm.matchType;
      this.matchData.contact = this.stepFourForm.contact;
      this.matchData.matchFormat = this.stepThreeForm.matchFormat;
      this.matchData.matchFieldType = this.stepThreeForm.matchFieldType;
      this.matchData.matchGroup = this.stepThreeForm.matchGroup;
      this.$confirm('请核实信息，确定要发布改赛事吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { res } = await this.$http.post('/Match/SaveMatch', this.matchData);
        if (res.isSuccess) {
          this.$showSuccess('发布成功');
          this.dialogVisible = false
          this.getMatchDetail();
        }
      });
    },
    showMap() {
      this.showMapDialog = true;
    },
    // 选择地址
    mapSubmit(location, address) {
      this.stepOneForm.stadiumAddress = address;
      this.stepOneForm.longitude = location.lng;
      this.stepOneForm.latitude = location.lat;
      this.showMapDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.infoPage {
  width: 100%;
  height: 100%;

  .bread-crumb {
    height: 30px;
  }

  .overviewCommand_detail {
    display: flex;
    align-items: center;
    width: 100%;

    .basic-left {
      width: 100%;
    }

    .basic-right {
      display: flex;
      justify-content: space-around;
      width: 50%;
      .uploadTitle {
        color: #fff;
      }
    }
  }
}


/deep/.el-input--small .el-input__inner {
  color: #e9e9e9;
}
.promptText {
  width: 90%;
  color: #2ba245;
  opacity: 0.6;
}

.wpct30 {
  width: 30%;
}

.btn-com {
  display: flex;
  justify-content: center;
  margin-top: 30px;

  .save-btn {
    color: #fff;
    background: rgb(51, 64, 84);
    width: 120px;
  }
}
</style>
 